import { UserProfile } from "@/__generated__/graphql";
import { Star } from "@mui/icons-material";
import { Avatar, Box, Card, LinearProgress, Stack, Typography } from "@mui/joy";
import { FormattedMessage } from "react-intl";

const CASHBACK_STEP = 1000;
const CASHBACK_MAX_SPENT = 5000;

const getCashbackPercentage = (totalSpent: number) =>
  Math.min(Math.floor(totalSpent / CASHBACK_STEP), 5);

export default function CashbackView({ user }: { user: UserProfile }) {
  const level = getCashbackPercentage(user.totalSpent);
  const toNextLevel = Math.round(CASHBACK_STEP - (user.totalSpent % CASHBACK_STEP));

  return (
    <Card variant="soft">
      <Stack direction="row" alignItems="center" gap={2}>
        <Avatar size="lg">
          <Star sx={{ color: "#D9347E" }} />
        </Avatar>
        <Box flex={1}>
          <Typography level="title-md">
            <FormattedMessage defaultMessage="Кешбэк {value}%" values={{ value: level }} />
          </Typography>
          <Typography level="body-sm" textColor="neutral.500">
            {user.totalSpent < CASHBACK_MAX_SPENT ? (
              <FormattedMessage
                defaultMessage="До {level}-го уровня: {value} BYN"
                values={{ value: toNextLevel, level: level + 1 }}
              />
            ) : (
              <FormattedMessage defaultMessage="Максимальный уровень" />
            )}
          </Typography>
        </Box>
        <Stack alignItems="flex-end">
          <Typography level="title-lg">{user.bonusBalance.toFixed(1)}</Typography>
          <Typography level="body-xs" textColor="neutral.500">
            <FormattedMessage defaultMessage="баллов" />
          </Typography>
        </Stack>
      </Stack>
      <LinearProgress
        determinate
        value={user.totalSpent < CASHBACK_MAX_SPENT ? (user.totalSpent % CASHBACK_STEP) / 10 : 100}
        sx={{ mt: 2 }}
      />
      <Typography level="body-xs" textColor="neutral.500" sx={{ mt: 1 }}>
        <FormattedMessage defaultMessage="Баллами можно оплатить до 50% стоимости любой покупки в AMANI" />
      </Typography>
    </Card>
  );
}
